// main.ts
import * as Sentry from "@sentry/vue";
import "./assets/css/style.scss";
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import "../node_modules/bootstrap-icons/font/bootstrap-icons.min.css";


import {createApp, ref} from "vue";
import apiPlugin from "@/plugins/apiPlugin";

import {createPinia} from "pinia";
import piniaPluginPersistedState from "pinia-plugin-persistedstate";
import App from "./App.vue";
import Notifications from "notiwind";
import {Auth0Plugin, createAuth0} from "@auth0/auth0-vue";


import router from "./router";


const app = createApp(App);

if (import.meta.env.PROD) {
  Sentry.init({
    app,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration(),
      Sentry.feedbackIntegration({
        colorScheme: "light",
        showName: false,
        triggerLabel: "Napište nám",
        triggerAriaLabel: "Otevřít formulář zpětné vazby",
        submitButtonLabel: "Odeslat",
        cancelButtonLabel: "Zrušit",
        formTitle: "Zlepšeme tuto aplikaci společně",
        messagePlaceholder: "Co se vám líbí nebo co byste rádi vylepšili?",
        messageLabel: "Vaše zpráva",
        emailLabel: "E-mail",
        emailPlaceholder: "vas@email.cz",
        successMessageText: "Děkujeme za zpětnou vazbu!",
        isRequiredLabel: "(povinné)",
        addScreenshotButtonLabel: "Přidat snímek obrazovky",
        removeScreenshotButtonLabel: "Odebrat snímek obrazovky",
      }),
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

const pinia = createPinia();
pinia.use(piniaPluginPersistedState);

app.use(pinia);
console.log(import.meta.env.VITE_AUTH0_AUDIENCE);

const auth0 =
    createAuth0({
        // použití env proměnných z .env
        domain: import.meta.env.VITE_AUTH0_DOMAIN,
        clientId: import.meta.env.VITE_AUTH0_CLIENT_ID,
        authorizationParams: {
            redirect_uri: import.meta.env.VITE_AUTH0_REDIRECT_URI,
            audience: import.meta.env.VITE_AUTH0_AUDIENCE,
        },
        useRefreshTokens: true,
        cacheLocation: 'localstorage',
    });

app.use(auth0);
app.use(apiPlugin);

app.use(Notifications);
app.use(router);


app.mount("#app");

export default app;
